import React from 'react';
import HeaderNav from "./_common/HeaderNav";
import {useHistory} from "react-router-dom";
import iconnotfound from '../assets/images/404.png'
import logo from '../assets/images/colzones-logo-128px.png'

const GenericNotFound = () => {
    const history = useHistory();

    return (
        <div className="container-fluid" id={'container-heading'}>
            <HeaderNav
                title={`Page non trouvée`}
                backToDo={() => history.push('/')}
                searchAction={false}
            />
            <div className={`container-data`} id={'not-found'}>
                <div className={'content'}>
                    <div className={'row'}>
                        <img className={'icon-not-found'} src={iconnotfound} alt={"Page non trouvée"}/>
                    </div>
                    <div className={'row'}>
                        <div className={'title-text-center'}>Ooops... Cette page n'existe pas</div>
                    </div>
                </div>
                <div className={'content-back'}>
                    <div className={'row'}>
                        <img className={'icon-logo'} src={logo} alt={"Page non trouvée"}/>
                    </div>
                    <div className={'row'}>
                        <button className={'btn-primary'} onClick={() => history.push('/')}>Retour à l'accueil</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GenericNotFound;